import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


import HomePage from './pages/HomePage';
import NotFound from './pages/NotFound';
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import SEBIMonthlyRecommendations from './components/portfolio/SEBIMonthlyRecommendations';
import AllWeatherPortfolio from './components/portfolio/AllWeatherPortfolio';
import DividendGrowthPortfolio from './components/portfolio/DividendGrowthPortfolio';
import LongTermGrowthPortfolio from './components/portfolio/LongTermGrowthPortfolio';
import IntradayCallsDashboard from './components/portfolio/IntradayCallsDashboard';
import HeatMapDashboard from './components/portfolio/HeatMapDashboard';
import PortfolioResearchDashboard from './components/portfolio/PortfolioResearchDashboard';
import RegisteredRAPlateform from './components/portfolio/RegisteredRAPlateform';
import FundamentalScreener from './components/portfolio/FundamentalScreener';
import PremiumDocs from './components/portfolio/premiumDoc';
import Nifty50 from './components/portfolio/Nifty50';
import ReturnScreener from './components/portfolio/ReturnScreener';
import IPOResearch from './components/portfolio/IPOResearch';
import BlogDetails from './pages/BlogDetails';
import Blogs from './pages/Blogs';
import SmoothScroll from './components/SmoothScrollbar';
import TermsConditions from './pages/TermsConditions';
import TermsManager from './pages/admin/TermsManager';
import PolicyManager from './pages/admin/PolicyManager';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';



// Admin Imports
import AdminHome from './pages/admin/HomePage';
import UsersPage from './pages/admin/UsersPage';
import UploadLogo from './pages/admin/UploadLogo';
import ContentAccess from './pages/admin/ContentAccess';
import LoginHistrory from './pages/admin/LoginHistrory';
import ContentUpdate from './pages/admin/ContentUpdate';
import UploadBlog from './pages/admin/UploadBlog';
import UploadPDF from './pages/admin/UploadPDF';
import DocPurchaseHistory from './pages/admin/DocPurchaseHistory';
import PageMetadataManager from './pages/admin/PageMetadataManager';
import AdminPortfolio from './pages/admin/AdminPortfolio';
import AdminLogin from './pages/admin/Loginpage';

import DemoPage from './pages/admin/DemoPage';
import Logout from './components/Logout';

import './App.css';

function ScrollHandler() {
  const location = useLocation();

  useEffect(() => {
    // Check if we have scrollTo state from navigation
    if (location.state && location.state.scrollTo) {
      // Wait for the page to render then scroll
      setTimeout(() => {
        const element = document.getElementById(location.state.scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
        
        // Clear the state to prevent scrolling on subsequent renders
        window.history.replaceState({}, document.title);
      }, 100); // Small delay to ensure DOM is ready
    }
  }, [location]);

  return null;
}
function App() {
  return (
    <Router>
      <ToastContainer position="top-right" />
      <ScrollHandler />
      <Routes>
        {/* Website Route */}
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/portfolio/sebi-monthly-recommendations" element={<SEBIMonthlyRecommendations />} />

        {/* New and complete routes */}
        <Route path="/portfolio/registered-ra-platform" element={<RegisteredRAPlateform />} />
        <Route path="/portfolio/intraday-calls-dashboard" element={<IntradayCallsDashboard />} />
        <Route path="/portfolio/heat-map-dashboard" element={<HeatMapDashboard />} />
        <Route path="/portfolio/research-dashboard" element={<PortfolioResearchDashboard />} />
        <Route path="/portfolio/long-term-growth-portfolio" element={<LongTermGrowthPortfolio />} />
        <Route path="/portfolio/fundamental-screener" element={<FundamentalScreener />} />
        <Route path="/portfolio/all-weather-portfolio" element={<AllWeatherPortfolio />} />
        <Route path="/portfolio/dividend-growth-portfolio" element={<DividendGrowthPortfolio />} />
        <Route path="/portfolio/nifty-50" element={<Nifty50 />} />
        <Route path="/portfolio/premium-docs" element={<PremiumDocs />} />
        <Route path="/portfolio/return-screener" element={<ReturnScreener />} />
        <Route path="/portfolio/ipo-research" element={<IPOResearch />} />
        <Route path="/blog/:id" element={<BlogDetails />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/logout" element={<Logout />} />


        {/* Admin Routes */}
        <Route path="/admin" element={<AdminHome />} />
        <Route path="/admin/users" element={<UsersPage />} />
        <Route path="/admin/users/content-access/:userId" element={<ContentAccess />} />
        <Route path="/admin/user/login-history" element={<LoginHistrory />} />
        <Route path="/admin/content-update" element={<ContentUpdate />} />
        <Route path="/admin/upload-logo" element={<UploadLogo />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/upload-blog" element={<UploadBlog />} />
        <Route path="/admin/upload-pdf" element={<UploadPDF />} />
        <Route path="/admin/doc-purchase-history" element={<DocPurchaseHistory />} />
        <Route path="/admin/page-metadata" element={<PageMetadataManager />} />
        <Route path="/admin/terms" element={<TermsManager />} />
        <Route path="/admin/demo" element={<DemoPage />} />
        <Route path="/admin/portfolio" element={<AdminPortfolio />} />
        <Route path="/admin/policies" element={<PolicyManager />} />

      </Routes>
    </Router>
  );
}

export default App;